"use strict";
exports.__esModule = true;
exports.TransactionStatus = void 0;
/**
 * @deprecated Use [ConfirmedTransactionStatus](../common/ConfirmedTransactionStatus.ts) or [PendingTransactionStatus](../common/PendingTransactionStatus.ts) instead.
 */
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["Pending"] = "PENDING";
    TransactionStatus["Confirmed"] = "CONFIRMED";
    TransactionStatus["Cancelled"] = "CANCELLED";
    TransactionStatus["Reversed"] = "REVERSED";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
